import React, { useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../Common/Pagination";
import WorkspaceList from "./WorkspaceList";
import WorkspaceForm from "./WorkspaceForm";
import PopupModal from "../Common/Popup";
import { useLocation } from "react-router-dom";

const WorkspaceBlock: React.FC = () => {
  const [count, setCount] = useState(0);
  const [limit] = useState(20);
  const [loading, setLoading] = useState(true);
  const [popupShow, setPopupShow] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = parseInt(queryParams.get('page') || '1');
  const [page, setPage] = useState(currentPage);

  return (
    <>
      <Row>
        <Col md={12}>
          <div className="my-3 p-3 bg-body rounded shadow-sm feature-box">
            <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
              <h6 className="heading mb-0">Workspace List</h6>
              <Button variant="primary" size="sm" onClick={() => { setPopupShow(true) }}>
                <FontAwesomeIcon className="me-2" icon={faPlus} />Create Workspace
              </Button>
            </div>

            <div className="d-none d-md-flex justify-content-end highlight-form-box border p-2 mb-0">
              <Col md="auto">
                <Pagination
                  page={page}
                  setPage={setPage}
                  count={count}
                  limit={limit}
                  setLoading={setLoading}
                />
              </Col>
            </div>

            <WorkspaceList
              page={page}
              setCount={setCount}
              limit={limit}
              loading={loading}
              setLoading={setLoading}
            />

            {/* <Pagination
              page={page}
              setPage={setPage}
              count={count}
              limit={limit}
              setLoading={setLoading}
            /> */}
          </div>
        </Col>
      </Row>

      <PopupModal title="Create New Workspace" popupShow={popupShow} setPopupShow={setPopupShow}>
        <WorkspaceForm setPopupShow={setPopupShow} refreshList={() => setPage(1)} />
      </PopupModal>
    </>
  );
};

export default WorkspaceBlock;
